// extracted by mini-css-extract-plugin
export default {"Section":"styles_Section__wDI3w","Section-inner":"styles_Section-inner__gu0D4"};